// ══════════════════════════════════════════════════════════════════════════════
// CATÉGORIES ANNONCES PARTICULIERS - 16 catégories avec sous-catégories
// Charte Abracadabâti: Bleu marine #1E3A5F et Orange #F97316 uniquement
// ══════════════════════════════════════════════════════════════════════════════

import { 
  Wrench, Zap, Hammer, PanelTop, Paintbrush, Waves, TreeDeciduous, 
  Truck, Package, Construction, Settings, Lightbulb, Thermometer, 
  Home, TreePine, ClipboardList, Droplets, Sun, Layers
} from 'lucide-react';

// Couleurs de la charte
const BLEU = '#1E3A5F';
const ORANGE = '#F97316';

export const CATEGORIES_PARTICULIERS = [
  {
    id: 'materiaux-construction',
    name: 'Matériaux de construction',
    icon: 'Construction',
    color: ORANGE,
    sousCategories: [
      { id: 'beton-ciment', name: 'Béton & ciment' },
      { id: 'briques-parpaings', name: 'Briques & parpaings' },
      { id: 'carrelage-dallage', name: 'Carrelage & dallage' },
      { id: 'pierre-naturelle', name: 'Pierre naturelle' },
      { id: 'isolation', name: 'Isolation' },
      { id: 'plaques-platre', name: 'Plaques de plâtre' },
      { id: 'mortiers', name: 'Mortiers' },
    ]
  },
  {
    id: 'electricite-plomberie',
    name: 'Électricité & Plomberie',
    icon: 'Zap',
    color: BLEU,
    sousCategories: [
      { id: 'cables-fils', name: 'Câbles & fils' },
      { id: 'tableaux-electriques', name: 'Tableaux électriques' },
      { id: 'tuyaux-raccords', name: 'Tuyaux & raccords' },
      { id: 'robinetterie', name: 'Robinetterie' },
      { id: 'sanitaires', name: 'Sanitaires' },
      { id: 'eclairage-elec', name: 'Éclairage' },
    ]
  },
  {
    id: 'outillage-electroportatif',
    name: 'Outillage & Électroportatif',
    icon: 'Hammer',
    color: BLEU,
    sousCategories: [
      { id: 'perceuses-visseuses', name: 'Perceuses & visseuses' },
      { id: 'meuleuses', name: 'Meuleuses' },
      { id: 'scies-rabots', name: 'Scies & rabots' },
      { id: 'niveaux-mesure', name: 'Niveaux & mesure' },
      { id: 'compresseurs', name: 'Compresseurs' },
      { id: 'generateurs', name: 'Générateurs' },
      { id: 'outillage-main', name: 'Outillage à main' },
    ]
  },
  {
    id: 'menuiserie-fermetures',
    name: 'Menuiserie & Fermetures',
    icon: 'PanelTop',
    color: ORANGE,
    sousCategories: [
      { id: 'portes-fenetres', name: 'Portes & fenêtres' },
      { id: 'volets-stores', name: 'Volets & stores' },
      { id: 'parquet-stratifie', name: 'Parquet & stratifié' },
      { id: 'escaliers', name: 'Escaliers' },
      { id: 'portails-clotures', name: 'Portails & clôtures' },
      { id: 'placards', name: 'Placards' },
    ]
  },
  {
    id: 'peinture-decoration',
    name: 'Peinture & Décoration',
    icon: 'Paintbrush',
    color: ORANGE,
    sousCategories: [
      { id: 'peintures-vernis', name: 'Peintures & vernis' },
      { id: 'enduits', name: 'Enduits' },
      { id: 'outils-peinture', name: 'Outils de peinture' },
      { id: 'papiers-peints', name: 'Papiers peints' },
      { id: 'revetements-muraux', name: 'Revêtements muraux' },
    ]
  },
  {
    id: 'piscine-spa',
    name: 'Piscine & Spa',
    icon: 'Waves',
    color: BLEU,
    sousCategories: [
      { id: 'pompes-filtration', name: 'Pompes & filtration' },
      { id: 'liner-baches', name: 'Liner & bâches' },
      { id: 'traitement-eau', name: 'Traitement eau' },
      { id: 'robots-nettoyeurs', name: 'Robots nettoyeurs' },
      { id: 'accessoires-piscine', name: 'Accessoires piscine' },
      { id: 'spas-jacuzzis', name: 'Spas & jacuzzis' },
    ]
  },
  {
    id: 'jardin-espaces-verts',
    name: 'Jardin & Espaces verts',
    icon: 'TreeDeciduous',
    color: BLEU,
    sousCategories: [
      { id: 'tondeuses-robots', name: 'Tondeuses & robots' },
      { id: 'taille-haies', name: 'Taille-haies' },
      { id: 'arrosage', name: 'Arrosage' },
      { id: 'terrasses-dallage', name: 'Terrasses & dallage' },
      { id: 'mobilier-jardin', name: 'Mobilier jardin' },
      { id: 'serres-abris', name: 'Serres & abris' },
    ]
  },
  {
    id: 'vehicules-remorques',
    name: 'Véhicules utilitaires & Remorques',
    icon: 'Truck',
    color: BLEU,
    sousCategories: [
      { id: 'fourgonnettes', name: 'Fourgonnettes' },
      { id: 'camionnettes', name: 'Camionnettes' },
      { id: 'remorques-chantier', name: 'Remorques chantier' },
      { id: 'nacelles', name: 'Nacelles' },
      { id: 'mini-pelleteuses', name: 'Mini-pelleteuses' },
      { id: 'compacteurs', name: 'Compacteurs' },
    ]
  },
  {
    id: 'materiel-chantier',
    name: 'Matériel de chantier',
    icon: 'Package',
    color: ORANGE,
    sousCategories: [
      { id: 'betonnieres', name: 'Bétonnières' },
      { id: 'compresseurs-chantier', name: 'Compresseurs' },
      { id: 'echafaudages', name: 'Échafaudages' },
      { id: 'echelles', name: 'Échelles' },
      { id: 'groupes-electrogenes', name: 'Groupes électrogènes' },
      { id: 'pompes', name: 'Pompes' },
    ]
  },
  {
    id: 'echafaudages-securite',
    name: 'Échafaudages & Sécurité',
    icon: 'Construction',
    color: BLEU,
    sousCategories: [
      { id: 'echafaudages-fixes', name: 'Échafaudages fixes' },
      { id: 'echafaudages-roulants', name: 'Échafaudages roulants' },
      { id: 'epi', name: 'EPI (casques, harnais...)' },
      { id: 'garde-corps', name: 'Garde-corps' },
      { id: 'filets-securite', name: 'Filets de sécurité' },
    ]
  },
  {
    id: 'quincaillerie-visserie',
    name: 'Quincaillerie & Visserie',
    icon: 'Settings',
    color: BLEU,
    sousCategories: [
      { id: 'vis-boulons', name: 'Vis & boulons' },
      { id: 'chevilles', name: 'Chevilles' },
      { id: 'clous-agrafes', name: 'Clous & agrafes' },
      { id: 'charnières-poignees', name: 'Charnières & poignées' },
      { id: 'serrurerie', name: 'Serrurerie' },
    ]
  },
  {
    id: 'eclairage-domotique',
    name: 'Éclairage & Domotique',
    icon: 'Lightbulb',
    color: ORANGE,
    sousCategories: [
      { id: 'ampoules-led', name: 'Ampoules LED' },
      { id: 'spots-projecteurs', name: 'Spots & projecteurs' },
      { id: 'luminaires', name: 'Luminaires' },
      { id: 'domotique', name: 'Domotique' },
      { id: 'interrupteurs-prises', name: 'Interrupteurs & prises' },
    ]
  },
  {
    id: 'chauffage-climatisation',
    name: 'Chauffage & Climatisation',
    icon: 'Thermometer',
    color: ORANGE,
    sousCategories: [
      { id: 'radiateurs', name: 'Radiateurs' },
      { id: 'chaudieres', name: 'Chaudières' },
      { id: 'pompes-chaleur', name: 'Pompes à chaleur' },
      { id: 'climatiseurs', name: 'Climatiseurs' },
      { id: 'poeles-inserts', name: 'Poêles & inserts' },
      { id: 'vmr', name: 'VMC' },
    ]
  },
  {
    id: 'couverture-toiture',
    name: 'Couverture & Toiture',
    icon: 'Home',
    color: BLEU,
    sousCategories: [
      { id: 'tuiles-ardoises', name: 'Tuiles & ardoises' },
      { id: 'gouttières', name: 'Gouttières' },
      { id: 'etancheite', name: 'Étanchéité' },
      { id: 'velux', name: 'Velux & fenêtres de toit' },
      { id: 'isolation-toiture', name: 'Isolation toiture' },
    ]
  },
  {
    id: 'bois-charpente',
    name: 'Bois & Charpente',
    icon: 'TreePine',
    color: ORANGE,
    sousCategories: [
      { id: 'charpente-traditionnelle', name: 'Charpente traditionnelle' },
      { id: 'charpente-fermettes', name: 'Fermettes industrielles' },
      { id: 'ossature-bois', name: 'Ossature bois' },
      { id: 'bardage-bois', name: 'Bardage bois' },
      { id: 'lambris-planches', name: 'Lambris & planches' },
    ]
  },
  {
    id: 'energie-solaire',
    name: 'Énergie solaire & Renouvelable',
    icon: 'Sun',
    color: ORANGE,
    sousCategories: [
      { id: 'panneaux-solaires', name: 'Panneaux solaires' },
      { id: 'onduleurs', name: 'Onduleurs' },
      { id: 'batteries-stockage', name: 'Batteries de stockage' },
      { id: 'chauffe-eau-solaire', name: 'Chauffe-eau solaire' },
      { id: 'kits-autoconsommation', name: 'Kits autoconsommation' },
    ]
  },
];

// ══════════════════════════════════════════════════════════════════════════════
// ICÔNES MAPPING - Pour utilisation avec Lucide React
// ══════════════════════════════════════════════════════════════════════════════

export const ICON_MAP = {
  'Construction': Construction,
  'Zap': Zap,
  'Hammer': Hammer,
  'PanelTop': PanelTop,
  'Paintbrush': Paintbrush,
  'Waves': Waves,
  'TreeDeciduous': TreeDeciduous,
  'Truck': Truck,
  'Package': Package,
  'Settings': Settings,
  'Lightbulb': Lightbulb,
  'Thermometer': Thermometer,
  'Home': Home,
  'TreePine': TreePine,
  'Sun': Sun,
  'Wrench': Wrench,
  'Droplets': Droplets,
  'Layers': Layers,
};

// Alias pour compatibilité
export const ICONS_MAP = ICON_MAP;

// ══════════════════════════════════════════════════════════════════════════════
// FILTRES DE DISTANCE - Rayons de recherche
// ══════════════════════════════════════════════════════════════════════════════

export const RAYONS_KM = [
  { id: 5, label: '5 km' },
  { id: 10, label: '10 km' },
  { id: 20, label: '20 km' },
  { id: 50, label: '50 km' },
  { id: 100, label: '100 km' },
  { id: 200, label: '200 km' },
  { id: 0, label: 'France entière' },
];

// ══════════════════════════════════════════════════════════════════════════════
// FILTRES DE DATE - Dates de publication
// ══════════════════════════════════════════════════════════════════════════════

export const DATES_PUBLICATION = [
  { id: 'all', label: 'Toutes les dates' },
  { id: '24h', label: 'Moins de 24h' },
  { id: '3days', label: 'Moins de 3 jours' },
  { id: '7days', label: 'Moins d\'une semaine' },
  { id: '30days', label: 'Moins d\'un mois' },
];

// ══════════════════════════════════════════════════════════════════════════════
// HELPERS
// ══════════════════════════════════════════════════════════════════════════════

// Obtenir l'icône Lucide d'une catégorie
export const getCategoryIcon = (iconName) => {
  return ICON_MAP[iconName] || Package;
};

// Obtenir une catégorie par ID
export const getCategoryById = (categoryId) => {
  return CATEGORIES_PARTICULIERS.find(cat => cat.id === categoryId);
};

// Obtenir les sous-catégories d'une catégorie
export const getSubcategories = (categoryId) => {
  const category = getCategoryById(categoryId);
  return category?.sousCategories || [];
};

// Formaté pour les select options
export const CATEGORIES_OPTIONS = CATEGORIES_PARTICULIERS.map(cat => ({
  value: cat.id,
  label: cat.name,
  icon: cat.icon,
}));

// Export default
export default CATEGORIES_PARTICULIERS;

// ══════════════════════════════════════════════════════════════════════════════
// TYPES D'ANNONCES - Types de publications possibles
// ══════════════════════════════════════════════════════════════════════════════

export const TYPES_ANNONCES = [
  { id: 'vente', label: 'Vente', icon: 'ShoppingBag', color: ORANGE },
  { id: 'achat', label: 'Achat', icon: 'ShoppingCart', color: BLEU },
  { id: 'location', label: 'Location', icon: 'Key', color: BLEU },
  { id: 'service', label: 'Service', icon: 'Wrench', color: ORANGE },
  { id: 'don', label: 'Don', icon: 'Gift', color: BLEU },
];

// ══════════════════════════════════════════════════════════════════════════════
// ÉTATS DU PRODUIT - Conditions de l'article
// ══════════════════════════════════════════════════════════════════════════════

export const ETATS_PRODUIT = [
  { id: 'neuf', label: 'Neuf', description: 'Article neuf, jamais utilisé' },
  { id: 'comme-neuf', label: 'Comme neuf', description: 'Utilisé très peu, parfait état' },
  { id: 'tres-bon', label: 'Très bon état', description: 'Quelques traces d\'utilisation légères' },
  { id: 'bon', label: 'Bon état', description: 'Fonctionne parfaitement, traces visibles' },
  { id: 'satisfaisant', label: 'Satisfaisant', description: 'Fonctionne, usure normale' },
  { id: 'a-reparer', label: 'À réparer', description: 'Ne fonctionne pas ou pièces manquantes' },
];

// ══════════════════════════════════════════════════════════════════════════════
// AUTOCOMPLETE SUGGESTIONS - Pour la recherche
// ══════════════════════════════════════════════════════════════════════════════

export const getAutocompleteSuggestions = (query) => {
  if (!query || query.length < 2) return [];
  
  const queryLower = query.toLowerCase();
  const suggestions = [];
  
  // Recherche dans les catégories
  CATEGORIES_PARTICULIERS.forEach(cat => {
    if (cat.name.toLowerCase().includes(queryLower)) {
      suggestions.push({
        type: 'category',
        id: cat.id,
        label: cat.name,
        icon: cat.icon,
        path: `/particuliers?category=${cat.id}`,
      });
    }
    
    // Recherche dans les sous-catégories
    cat.sousCategories.forEach(sub => {
      if (sub.name.toLowerCase().includes(queryLower)) {
        suggestions.push({
          type: 'subcategory',
          id: sub.id,
          label: sub.name,
          parentLabel: cat.name,
          icon: cat.icon,
          path: `/particuliers?category=${cat.id}&subcategory=${sub.id}`,
        });
      }
    });
  });
  
  return suggestions.slice(0, 8); // Limiter à 8 suggestions
};
